import {createI18nPlugin} from '@malt/vue3-i18n';

const messages = {...window.HopMessages, ...window.ScreenMessages};
export const {I18nPlugin, I18nService} = createI18nPlugin({messages});
